export function toE164(value) {
  const digits = value.replace(/[^0-9]/g, '');
  return `+${digits}`;
}
//# sourceMappingURL=format-phone-number.js.map